angular.module('pe4h').run(['$templateCache', function($templateCache) {
  $templateCache.put('components/main/main.html',
    '<update-title title="Need an Engineer? | Get Competitive Bids Today | PEforHire.com"></update-title>\n' +
    '<update-meta name="description" content="Post your project and receive proposals from highly qualified licensed Professional Engineers (PEs) for FREE! P.E. For Hire is fast and intuitive, allowing you to get the engineering expertise you need, when you need it. Post today, hire tomorrow!"></update-meta>\n' +
    '\n' +
    '<!-- Top Display -->\n' +
    '<section class="content-display-home">\n' +
    '    <div>\n' +
    '        <div class="container get-started-home">\n' +
    '            <h1>Got the Project? We\'ve Got the&nbsp;Engineer</h1>\n' +
    '            <h3>Get FREE Quotes from Qualified&nbsp;Engineers</h3>\n' +
    '            <div class="buttons">\n' +
    '                <a href="" data-toggle="modal" data-target="#modal-video">SEE HOW IT WORKS</a>\n' +
    '                <button ng-click="handleClickGetStarted()" class=\'btn btn-primary\'>Get Started</button>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="engineer-icons">\n' +
    '            <div class="left">\n' +
    '                <div class="icon-container" ng-repeat="icon in [\n' +
    '                2,3,5,8,9,10,11,12,15,16,17,18,20,21,22,23,24\n' +
    '                ] track by $index">\n' +
    '                    <img ng-src="https://s3-us-west-2.amazonaws.com/pe4hdev/engineer-icons/{{icon}}.svg" />\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="center">\n' +
    '                <div class="icon-container" ng-repeat="icon in [\n' +
    '                6, 13, 7, 4, 21, 3, 14, 19,\n' +
    '                6, 13, 7, 4, 21, 3, 14, 19\n' +
    '                ] track by $index">\n' +
    '                    <img ng-src="https://s3-us-west-2.amazonaws.com/pe4hdev/engineer-icons/{{icon}}.svg" />\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="left last">\n' +
    '                <div class="icon-container" ng-repeat="icon in [\n' +
    '                22,23,24,9,8,5,3,2,16,17,18,19,20,21\n' +
    '                ] track by $index">\n' +
    '                    <img ng-src="https://s3-us-west-2.amazonaws.com/pe4hdev/engineer-icons/{{icon}}.svg" />\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="white-cover"></div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</section>\n' +
    '\n' +
    '<!-- How it Works -->\n' +
    '<section class="content how-it-works bg-grey">\n' +
    '    <div class="container">\n' +
    '        <div class="row">\n' +
    '            <h2>How it Works</h2>\n' +
    '            <h4>Watch the video to see what <span>P.E. For Hire</span> can do for you!</h4>\n' +
    '            <div class="hexagon-md" data-toggle="modal" data-target="#modal-video">\n' +
    '                <i class="fa fa-play-circle fa-5x"></i>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</section>\n' +
    '\n' +
    '<!-- Tiles -->\n' +
    '<section class="content tiles">\n' +
    '    <div class="container-fluid">\n' +
    '        <div class="row">\n' +
    '            <div class="col-sm-6 col-sm-push-6 mb-15 tile-bg">\n' +
    '                <!-- Centered & Middle -->\n' +
    '                <div class="vertical-middle">\n' +
    '                    <div class="vertical-block tiles-promo">\n' +
    '                        <h2>Post Your Project<br>IT\'S FREE!</h2>\n' +
    '                        <svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">\n' +
    '                            <path d="M90.7 70.4h-3V11.2h3c0.8 0 1.4-0.6 1.4-1.4 0-0.8-0.7-1.4-1.4-1.4H51.4V6.4C51.4 5.6 50.8 5 50 5c-0.8 0-1.4 0.6-1.4 1.4v1.8H9.3c-0.8 0-1.4 0.6-1.4 1.4 0 0.8 0.6 1.4 1.4 1.4h3v59.2h-3c-0.8 0-1.4 0.6-1.4 1.4 0 0.8 0.6 1.4 1.4 1.4h28.9L18.9 92.5c-0.6 0.6-0.6 1.5 0 2 0.3 0.3 0.7 0.4 1 0.4 0.4 0 0.7-0.1 1-0.4l21.3-21.3h6.4v16.2c0 0.8 0.6 1.4 1.4 1.4 0.8 0 1.4-0.6 1.4-1.4V73.3h6.3l21.3 21.3c0.3 0.3 0.7 0.4 1 0.4 0.4 0 0.7-0.1 1-0.4 0.6-0.6 0.6-1.5 0-2L61.9 73.3h28.9c0.8 0 1.4-0.6 1.4-1.4C92.2 71 91.5 70.4 90.7 70.4zM84.9 70.4H15.1V11.2h69.8V70.4z" />\n' +
    '                            <path d="M44.7 25.5v3.3c0 0.8-0.6 1.4-1.4 1.4 -0.8 0-1.4-0.6-1.4-1.4v-0.2h-3v10.2H39c0.8 0 1.4 0.6 1.4 1.4 0 0.8-0.6 1.4-1.4 1.4h-3.3c-0.8 0-1.4-0.6-1.4-1.4 0-0.8 0.6-1.4 1.4-1.4h0.2V28.5h-3.6v0.2c0 0.8-0.7 1.4-1.4 1.4 -0.8 0-1.4-0.6-1.4-1.4v-3.3c0-0.8 0.6-1.4 1.4-1.4 0.8 0 1.4 0.6 1.4 1.4v0.2h9.5v-0.2c0-0.8 0.7-1.4 1.4-1.4C44.1 24 44.7 24.7 44.7 25.5z" />\n' +
    '                            <path d="M69 49.5H30.9c-0.8 0-1.4-0.6-1.4-1.4 0-0.8 0.6-1.4 1.4-1.4H69c0.8 0 1.4 0.6 1.4 1.4C70.5 48.9 69.8 49.5 69 49.5z" />\n' +
    '                            <path d="M69 57.2H30.9c-0.8 0-1.4-0.6-1.4-1.4 0-0.8 0.6-1.4 1.4-1.4H69c0.8 0 1.4 0.6 1.4 1.4C70.5 56.6 69.8 57.2 69 57.2z" />\n' +
    '                            <path d="M69 33.9H50c-0.8 0-1.4-0.6-1.4-1.4 0-0.8 0.6-1.4 1.4-1.4h19c0.8 0 1.4 0.6 1.4 1.4C70.5 33.3 69.8 33.9 69 33.9z" />\n' +
    '                            <path d="M69 41.6H50c-0.8 0-1.4-0.6-1.4-1.4 0-0.8 0.6-1.4 1.4-1.4h19c0.8 0 1.4 0.6 1.4 1.4C70.5 41 69.8 41.6 69 41.6z" />\n' +
    '                        </svg>\n' +
    '                        <p>Fill out the <a href="" ui-sref="post-project({first: true})">request form</a> and\n' +
    '                            submit. P.E. For Hire saves you time and money locating and hiring licensed Professional\n' +
    '                            Engineers for your short to long-term projects.</p>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="col-sm-6 col-sm-pull-6 tile-left tiles-promo" style="background-image:url(\'assets/img/screens-post-project.png\');"></div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '            <div class="col-sm-6 mb-15 tile-bg">\n' +
    '                <!-- Centered & Middle -->\n' +
    '                <div class="vertical-middle">\n' +
    '                    <div class="vertical-block tiles-promo">\n' +
    '                        <h2>Hire the Best Candidate</h2>\n' +
    '                        <svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">\n' +
    '                            <path d="M90.7 70.4h-3V11.2h3c0.8 0 1.4-0.6 1.4-1.4 0-0.8-0.6-1.4-1.4-1.4H51.4V6.4C51.4 5.6 50.8 5 50 5c-0.8 0-1.4 0.6-1.4 1.4v1.8H9.3c-0.8 0-1.4 0.6-1.4 1.4 0 0.8 0.6 1.4 1.4 1.4h3v59.2h-3c-0.8 0-1.4 0.6-1.4 1.4 0 0.8 0.6 1.4 1.4 1.4h28.9L18.9 92.5c-0.6 0.6-0.6 1.5 0 2 0.3 0.3 0.7 0.4 1 0.4 0.4 0 0.7-0.1 1-0.4l21.3-21.3h6.3v16.2c0 0.8 0.6 1.4 1.4 1.4 0.8 0 1.4-0.6 1.4-1.4V73.3h6.3l21.3 21.3c0.3 0.3 0.7 0.4 1 0.4 0.4 0 0.7-0.1 1-0.4 0.6-0.6 0.6-1.5 0-2L61.9 73.3h28.9c0.8 0 1.4-0.6 1.4-1.4C92.2 71 91.5 70.4 90.7 70.4zM84.9 70.4H15.1V11.2h69.8V70.4z" />\n' +
    '                            <path d="M36.6 64.7H22.6c-0.8 0-1.4-0.6-1.4-1.4V49.2c0-0.8 0.6-1.4 1.4-1.4h14.1c0.8 0 1.4 0.6 1.4 1.4v14.1C38.1 64 37.4 64.7 36.6 64.7zM24 61.8h11.2V50.6H24V61.8z" />\n' +
    '                            <path d="M57 64.7H43c-0.8 0-1.4-0.6-1.4-1.4V49.2c0-0.8 0.6-1.4 1.4-1.4H57c0.8 0 1.4 0.6 1.4 1.4v14.1C58.5 64 57.8 64.7 57 64.7zM44.4 61.8h11.2V50.6H44.4V61.8z" />\n' +
    '                            <path d="M77.4 64.7H63.4c-0.8 0-1.4-0.6-1.4-1.4V49.2c0-0.8 0.6-1.4 1.4-1.4h14.1c0.8 0 1.4 0.6 1.4 1.4v14.1C78.9 64 78.2 64.7 77.4 64.7zM64.8 61.8H76V50.6H64.8V61.8z" />\n' +
    '                            <path d="M63.5 37.2H36.5c-0.8 0-1.4-0.6-1.4-1.4 0-0.8 0.6-1.4 1.4-1.4h26.9c0.8 0 1.4 0.6 1.4 1.4C64.9 36.5 64.3 37.2 63.5 37.2z" />\n' +
    '                            <path d="M54.9 42.8h-9.7c-0.8 0-1.4-0.6-1.4-1.4 0-0.8 0.6-1.4 1.4-1.4h9.7c0.8 0 1.4 0.6 1.4 1.4C56.3 42.1 55.7 42.8 54.9 42.8z" />\n' +
    '                            <path d="M50 30.5c-3.9 0-7-3.2-7-7 0-3.9 3.2-7 7-7s7 3.2 7 7C57 27.4 53.9 30.5 50 30.5zM50 19.4c-2.3 0-4.1 1.9-4.1 4.1s1.9 4.1 4.1 4.1 4.1-1.9 4.1-4.1S52.3 19.4 50 19.4z" />\n' +
    '                        </svg>\n' +
    '                        <p>We connect you to a nationwide pool of licensed Professional Engineers entirely online.\n' +
    '                            Review all your bids and engineer profiles using a convenient dashboard.</p>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="col-sm-6 tile-right tiles-promo" style="background-image:url(\'assets/img/screens-view-proposals.png\');"></div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '            <div class="col-sm-6 col-sm-push-6 mb-15 tile-bg">\n' +
    '                <!-- Centered & Middle -->\n' +
    '                <div class="vertical-middle">\n' +
    '                    <div class="vertical-block tiles-promo">\n' +
    '                        <h2>Safely Pay For the Work</h2>\n' +
    '                        <svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">\n' +
    '                            <path d="M90.7 70.4h-3V11.2h3c0.8 0 1.4-0.6 1.4-1.4s-0.6-1.4-1.4-1.4H51.4V6.4C51.4 5.6 50.8 5 50 5c-0.8 0-1.4 0.6-1.4 1.4v1.8H9.3c-0.8 0-1.4 0.6-1.4 1.4s0.7 1.4 1.4 1.4h3v59.2h-3c-0.8 0-1.4 0.6-1.4 1.4s0.7 1.4 1.4 1.4h28.9L18.9 92.5c-0.6 0.6-0.6 1.5 0 2 0.3 0.3 0.6 0.4 1 0.4 0.4 0 0.7-0.1 1-0.4l21.3-21.3h6.3v16.2c0 0.8 0.7 1.4 1.4 1.4 0.8 0 1.4-0.6 1.4-1.4V73.3h6.3l21.3 21.3c0.3 0.3 0.7 0.4 1 0.4 0.4 0 0.7-0.1 1-0.4 0.6-0.6 0.6-1.5 0-2L61.9 73.3h28.9c0.8 0 1.4-0.6 1.4-1.4S91.5 70.4 90.7 70.4zM15.1 70.4V11.2h69.8v59.2H15.1z" />\n' +
    '                            <path d="M50 57.7c-9.4 0-17-7.6-17-17s7.6-17 17-17 17 7.6 17 17S59.4 57.7 50 57.7zM50 26.7c-7.8 0-14.1 6.3-14.1 14.1S42.2 54.9 50 54.9s14.1-6.3 14.1-14.1S57.8 26.7 50 26.7z" />\n' +
    '                            <path d="M48 46.2c-0.4 0-0.7-0.1-1-0.4l-4-4c-0.6-0.6-0.6-1.5 0-2 0.6-0.6 1.5-0.6 2 0l3 3 7-7c0.6-0.6 1.5-0.6 2 0 0.6 0.6 0.6 1.5 0 2l-8 8C48.7 46.1 48.4 46.2 48 46.2z" />\n' +
    '                        </svg>\n' +
    '                        <p>Place funds into our secure payment processing platform, powered by Escrow.com. Release funds once the work is complete and you are satisfied.</p>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="col-sm-6 col-sm-pull-6 tile-left tiles-promo" style="background-image:url(\'assets/img/screens-hire-engineers.png\');"></div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</section>\n' +
    '\n' +
    '<!-- Quote -->\n' +
    '<section class="content bg-grey">\n' +
    '    <div class="container-fluid">\n' +
    '        <div class="row">\n' +
    '            <div class="col-xs-12 col-sm-8 col-sm-offset-2">\n' +
    '                <blockquote>\n' +
    '                    <h2>It was such a fast and easy process! I was surprised how quickly I received proposals. This is\n' +
    '                        going to save me lots of time finding the right engineers for my projects.</h2>\n' +
    '                </blockquote>\n' +
    '                <div class="author">Denny G.</div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</section>\n' +
    '\n' +
    '<!-- Promo to Start -->\n' +
    '<section class="content get-started">\n' +
    '    <div class="container-fluid">\n' +
    '        <div class="row">\n' +
    '            <div class="col-xs-12 col-sm-6">\n' +
    '                <div class="get-started-features">\n' +
    '                    <div class="core-features">\n' +
    '                        <div class="hexagon-sm">\n' +
    '                            <i class="fa fa-bell-o fa-fw" aria-hidden="true"></i>\n' +
    '                        </div>\n' +
    '                        <h3>Get the Projects You Want, Delivered to Your Inbox!</h3>\n' +
    '                        <a href="" ui-sref="signup">Signup now</a> and create your online profile. Receive instant\n' +
    '                        email notifications when there\'s a project for you.\n' +
    '                        <br>\n' +
    '                    </div>\n' +
    '                    <div class="core-features">\n' +
    '                        <div class="hexagon-sm">\n' +
    '                            <i class="fa fa-paper-plane-o fa-fw" aria-hidden="true"></i>\n' +
    '                        </div>\n' +
    '                        <h3>Submit an Estimate For FREE!</h3>\n' +
    '                        When you see a project you like, submit an estimate. Manage your proposals and \n' +
    '                        projects with a convenient dashboard.\n' +
    '                    </div>\n' +
    '                    <div class="core-features">\n' +
    '                        <div class="hexagon-sm">\n' +
    '                            <i class="fa fa-balance-scale fa-fw" aria-hidden="true"></i>\n' +
    '                        </div>\n' +
    '                        <h3>Safely Get Paid</h3>\n' +
    '                        Ensure you get paid by submitting your invoice through our secure payment processing \n' +
    '                        platform, powered by Escrow.com. Once you’ve completed the work, funds will be released. \n' +
    '                        It’s that easy!\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="col-xs-12 col-sm-6 get-started-photo" style="background-image:url(\'assets/img/woman-with-notebook-in-office-bg.jpg\');">\n' +
    '                <h2>Are you a licensed<br>\n' +
    '                    Professional Engineer?</h2>\n' +
    '                <a class="btn btn-primary btn-lg" href="" ui-sref="signup">Join as an Engineer</a>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</section>\n' +
    '\n' +
    '<!-- Modal -->\n' +
    '<div id="modal-video" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">\n' +
    '    <div class="modal-dialog modal-video">\n' +
    '        <a class="close" data-dismiss="modal" aria-label="Close"></a>\n' +
    '        <div class="youtube">\n' +
    '            <iframe width="560" height="315" src="https://www.youtube.com/embed/R0MJdOLS8z8?rel=0&amp;hd=1&amp;enablejsapi=1"\n' +
    '                allowfullscreen></iframe>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-eng.html">\n' +
    '    <div class="modal-header">\n' +
    '        <a class="close" ng-click="$close();">\n' +
    '            <i class="fa fa-times"></i>\n' +
    '        </a>\n' +
    '        <h4 class="modal-title">Modal Small</h4>\n' +
    '    </div>\n' +
    '    <div class="modal-body">\n' +
    '        Modal window is an UI element that subordinate of a main-window which opens a mode where the main window is blocked by it\'s child window.\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '        <button type="button" ng-click="$close();">OK</button>\n' +
    '    </div>\n' +
    '</script>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-professional-email.html">\n' +
    '    <div class="modal-header">\n' +
    '        <a class="close" ng-click="$close();">\n' +
    '            <i class="fa fa-times"></i>\n' +
    '        </a>\n' +
    '        <h4 class="modal-title">OOPS!</h4>\n' +
    '    </div>\n' +
    '    <div class="modal-body">\n' +
    '        <p>We\'re sorry, but this email address is associated with an engineer\'s profile.</p>\n' +
    '        <p>You must log out and use a different email address to continue.</p>\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '        <a class="btn btn-primary" href="" ng-click="$close();" aria-label="Close">Close</a>\n' +
    '    </div>\n' +
    '</script>');
}]);
